import type { FC } from 'react'
import styled from 'styled-components'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  a: boolean
  b: boolean
  c: boolean
  d: boolean
  e: boolean
  f: boolean
  g: boolean
  h: boolean
  i: boolean
  j: boolean
  k: boolean
  l: boolean
  m: boolean
  n: boolean
  other: boolean
}

export const DEFAULT_FILTER: Filter = {
  a: true,
  b: true,
  c: true,
  d: true,
  e: true,
  f: true,
  g: true,
  h: true,
  i: true,
  j: true,
  k: true,
  l: true,
  m: true,
  n: true,
  other: true,
}

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const OuterContainer = styled.div`
  display: grid;
  grid-gap: 10px;
`

const LinksContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`

const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 10px;
`

const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #0075ff;
  }
`

const SubHeading = styled.span`
  font-weight: bold;
`

const SwimLaneGroupFilter: FC<Props> = ({ filter, onChangeFilter }) => {
  const onSelectAll = () => onChangeFilter(DEFAULT_FILTER)

  const onClearAll = () =>
    onChangeFilter({
      a: false,
      b: false,
      c: false,
      d: false,
      e: false,
      f: false,
      g: false,
      h: false,
      i: false,
      j: false,
      k: false,
      l: false,
      m: false,
      n: false,
      other: false,
    })

  return (
    <OuterContainer>
      <LinksContainer>
        <div>
          <Link onClick={onClearAll}>Clear all</Link>
        </div>
        <div>
          <Link onClick={onSelectAll}>Select all</Link>
        </div>
      </LinksContainer>
      <SubHeading>Wing 1</SubHeading>
      <InnerContainer>
        <Checkbox
          label="A"
          checked={filter.a}
          onChange={e =>
            onChangeFilter({
              ...filter,
              a: e.target.checked,
            })
          }
        />
        <Checkbox
          label="B"
          checked={filter.b}
          onChange={e =>
            onChangeFilter({
              ...filter,
              b: e.target.checked,
            })
          }
        />
        <Checkbox
          label="C"
          checked={filter.c}
          onChange={e =>
            onChangeFilter({
              ...filter,
              c: e.target.checked,
            })
          }
        />
        <Checkbox
          label="G"
          checked={filter.g}
          onChange={e =>
            onChangeFilter({
              ...filter,
              g: e.target.checked,
            })
          }
        />
        <Checkbox
          label="I"
          checked={filter.i}
          onChange={e =>
            onChangeFilter({
              ...filter,
              i: e.target.checked,
            })
          }
        />
      </InnerContainer>
      <SubHeading>Wing 2</SubHeading>
      <InnerContainer>
        <Checkbox
          label="D"
          checked={filter.d}
          onChange={e =>
            onChangeFilter({
              ...filter,
              d: e.target.checked,
            })
          }
        />
        <Checkbox
          label="E"
          checked={filter.e}
          onChange={e =>
            onChangeFilter({
              ...filter,
              e: e.target.checked,
            })
          }
        />
        <Checkbox
          label="J"
          checked={filter.j}
          onChange={e =>
            onChangeFilter({
              ...filter,
              j: e.target.checked,
            })
          }
        />
        <Checkbox
          label="K"
          checked={filter.k}
          onChange={e =>
            onChangeFilter({
              ...filter,
              k: e.target.checked,
            })
          }
        />
        <Checkbox
          label="L"
          checked={filter.l}
          onChange={e =>
            onChangeFilter({
              ...filter,
              l: e.target.checked,
            })
          }
        />
      </InnerContainer>
      <InnerContainer>
        <Checkbox
          label="Other"
          checked={filter.other}
          onChange={e =>
            onChangeFilter({
              ...filter,
              other: e.target.checked,
            })
          }
        />
      </InnerContainer>
    </OuterContainer>
  )
}

export default SwimLaneGroupFilter
